/* eslint-disable react/prop-types */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2.000000, 0.000000)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33,1.31665457 C33,0.872662082 32.7794768,0.471668868 32.4715391,0.250672607 C32.1179073,-0.0163228748 31.676861,-0.0603221303 31.2805153,0.0726756192 L11.4711779,6.73456289 C10.9417236,6.91255988 10.5880919,7.44555086 10.5880919,7.97754186 L10.5880919,28.0072029 C9.48547605,27.1642172 8.11763643,26.6752255 6.61768159,26.6752255 C2.9562024,26.6752255 0,29.6511751 0,33.3371127 C0,37.0240504 2.9562024,40 6.61768159,40 C10.1470455,40 13.0595407,37.1570481 13.1916559,33.6041082 L13.1916559,33.4261112 L13.1916559,14.8624254 L30.353722,9.08752308 L30.353722,22.0123044 C29.2511062,21.1693186 27.8832666,20.6793269 26.3823184,20.6793269 C22.7208392,20.6793269 19.7656302,23.6552766 19.7656302,27.3412142 C19.7656302,31.0281518 22.7208392,34.0041015 26.3823184,34.0041015 C29.9126757,34.0041015 32.8231841,31.1611496 32.9562927,27.6082097 L32.9562927,27.4302127 L32.9562927,1.31665457 L33,1.31665457 Z"
})))), 'CategoryMS', {
  viewBox: '0 0 33 40'
});